import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  searchInstitutions,
  setFilterInput,
  setSearchTerm,
  updateFilterInput
} from './institutions.actions';
import {
  institutionsLoading,
  selectInstitutions,
  selectInstitutionsFilterInput,
  selectTotal
} from './institutions.selectors';
import { Observable } from 'rxjs';
import { Institution } from 'src/generated/graphql';
import { InstitutionsFilter } from '../../models/institutions-filter';

@Injectable({
  providedIn: 'root'
})
export class InstitutionsFacadeService {
  public get loading$(): Observable<boolean> {
    return this.store.select(institutionsLoading);
  }

  public get institutions$(): Observable<Institution[]> {
    return this.store.select(selectInstitutions);
  }

  public get total$(): Observable<number> {
    return this.store.select(selectTotal);
  }

  public get institutionsFilterInput$(): Observable<InstitutionsFilter> {
    return this.store.select(selectInstitutionsFilterInput);
  }

  constructor(private store: Store) {}

  public searchInstitutions(): void {
    this.store.dispatch(searchInstitutions());
  }

  public setFilterInput(filterInput: InstitutionsFilter): void {
    this.store.dispatch(setFilterInput({ filterInput }));
  }

  public updateFilterInput(filterInput: InstitutionsFilter): void {
    this.store.dispatch(updateFilterInput({ filterInput }));
  }

  public setSearchTerm(searchTerm: string): void {
    this.store.dispatch(setSearchTerm({ searchTerm }));
  }
}
